import React from 'react';

const Accordion = ({ title, isOpen, setIsOpen, children, summary }) => (
  <div className="border border-gray-200 rounded-lg">
    <div className={`accordion-header flex justify-between items-center p-3 cursor-pointer bg-gray-50 hover:bg-gray-100 ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
      <div className="font-semibold text-gray-800">{title}</div>
      <div className="flex items-center space-x-4">
        {summary && !isOpen && <p className="text-sm text-gray-600 font-medium">{summary}</p>}
        <svg className={`w-5 h-5 text-gray-500 transform transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
      </div>
    </div>
    <div className={`accordion-content ${isOpen ? 'open' : ''}`}>
      {isOpen && <div className="p-4 border-t border-gray-200">{children}</div>}
    </div>
  </div>
);

export default Accordion;